import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import './utils/loadLang'
import vuetify from './plugins/vuetify';
import './plugins/axios'
import i18n from './i18n'
import localStorageSync from './utils/localstorageSync'
localStorageSync.syncData()


Vue.config.productionTip = false

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});

new Vue({
  el: "#wacg",
  vuetify,
  store,
  i18n,
  render: h => h(App)
})
